import React, { Fragment } from 'react'
import { bool, string, func } from 'prop-types'
import { useSelector } from 'react-redux'
import StatusModal from '../StatusModal/StatusModal'
import { selectLabels } from '../../redux/configuration/selectors'
import statusModalImage from '../../assets/images/brand-status-image.png'

const SessionWarningModal = ({ isOpen, countdown, onContinueBookingClick }) => {
  const labels = useSelector(selectLabels)

  return (
    <StatusModal
      backgroundUrl={statusModalImage}
      backgroundAltLabel={labels.warningTitle}
      labels={labels}
      isOpen={isOpen}
    >
      <Fragment>
        <h4 className="modal-col-title center-text theme-font-header">
          {labels.warningTitle}
        </h4>
        <p>
          {labels.warningContent} {countdown}
        </p>
        <button onClick={onContinueBookingClick} className="btn btn-primary">
          {labels.warningContinue}
        </button>
      </Fragment>
    </StatusModal>
  )
}

SessionWarningModal.propTypes = {
  isOpen: bool.isRequired,
  countdown: string.isRequired,
  onContinueBookingClick: func.isRequired
}

export default SessionWarningModal
